/** @file 签到 语言配置 */
const zhCN = {
  checkIn: {
    second: '秒',
    checkInBtn: '立即签到',
    checkInTimeTip: '距离签到结束还有',
    signIn: '签到',
    submitFail: '提交失败',
    submitEndFail: '签到已结束',
    record: '签到记录',
    checkInSuccess: '签到成功',
    checkInTime: '签到时间',
    checkInStatus: '签到状态',
    checkInOver: '已签到',
    checkInNot: '未签到',
    NoRecord: '暂无记录',
    close: '关闭'
  },
};

const en = {
  checkIn: {
    second: 'S',
    checkInBtn: 'Sign in',
    checkInTimeTip: 'until the end of the check-in',
    signIn: 'Sign in',
    submitFail: 'Submit Fail',
    submitEndFail: 'Sign in End',
    record: 'Sign in record',
    checkInSuccess: 'Success',
    checkInTime: 'Time',
    checkInStatus: 'Status',
    checkInOver: 'Signed in',
    checkInNot: 'Not signed in',
    NoRecord: 'No record',
    close: 'Close'

  },
};

export default {
  zh_CN: zhCN,
  en,
};
